<template>
  <Cascader v-if="categories" :disabled="disabled" :data="categories" :value="selectedValues"
    trigger="click"
    filterable
    transfer
    :render-format="categoryFormat"
    :change-on-select="allowParentSelect"
    @on-change="handleSelectCategory" ref="categorySelect"
    placeholder="Category">

  </Cascader>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PartCategorySelect',
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    classNumber: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowParentSelect: {
      type: Boolean,
      default: true
    },
    aggResults: {
      type: Array
    },
    componentType: {
      type: String
    }
  },
  data() {
    return {
      categories: [],
      cascaderValues: {},
      categoryData: {},
      currentCategory: ''
    }
  },
  mounted() {
    this.loadCategories()
  },
  computed: {
    selectedValues: function () {
      return _.get(this.cascaderValues, this.categoryId, [])
    }
  },
  watch: {
    aggResults: {
      handler: function () {
        this.setLevelValue(this.categories)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'getPartCategoryTree',
      'getPartCategory'
    ]),
    handleSelectCategory(ids, selected) {
      if (!_.isEmpty(ids)) {
        let categoryId = _.last(_.clone(ids))
        this.$emit('update:categoryId', this.categoryData[categoryId].id)
        this.$emit('update:classNumber', this.categoryData[categoryId].class_number)
        this.$emit('change', this.categoryData[categoryId])
      } else {
        this.$emit('update:categoryId', null)
        this.$emit('update:classNumber', null)
        this.$emit('change', null)
      }
    },
    loadCategories() {
      this.getPartCategoryTree(this.componentType).then(res => {
        this.setLevelValue(res)
        this.categories = res
      })
    },
    setLevelValue(categories) {
      _.each(categories, (n) => {
        let categoryAggResult = this.findAggResult(n.class_number)
        let countDesc = categoryAggResult ? '　' + `N: ${categoryAggResult.doc_count}` : ''

        n.label = n.chinese_name + ' ' + n.name + ' ' + countDesc + '　'
        n.value = n.id

        // n.disabled = this.shouldDisabled(n)
        var idValues = _.clone([n.id])
        if (n.parent_id) {
          idValues = _.concat(_.get(this.cascaderValues, n.parent_id, []), idValues)
        }
        this.$set(this.cascaderValues, n.id, _.clone(idValues))
        let cloneN = _.cloneDeep(n)
        this.$set(this.categoryData, n.id, _.cloneWith(cloneN, (item) => {
          delete item.children
        }))
        // this.$set(this.cascaderValues, n.id, idValues)
        if (n.children && n.children.length > 0) {
          this.setLevelValue(n.children)
        }
      })
    },
    findAggResult(class_number) {
      if (this.aggResults) {
        return _.find(this.aggResults, (o) => { return o.key === class_number })
      }
      return false
    },
    categoryFormat (labels, selectedData) {
      return _.last(labels)
    }
  }
}
</script>
